<template>
  <b-card>
    <div class="chart-wrapper">
      <canvas
        v-if="chartData"
        ref="canvas"
      />
    </div>
  </b-card>
</template>

<script>
import { Line } from 'vue-chartjs'
import { BCard } from 'bootstrap-vue'

export default {
  name: 'HourlyScansChart',
  components: { BCard },
  extends: Line,
  props: {
    sessions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'top',
          labels: {
            fontSize: 13,
            fontColor: '#444',
            boxWidth: 12,
          },
        },
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Hour',
                fontColor: '#333',
                fontSize: 14,
                fontStyle: 'bold',
              },
              ticks: {
                fontColor: '#666',
                autoSkip: true,
                maxRotation: 30,
                minRotation: 30,
              },
              gridLines: {
                color: '#eee',
              },
            },
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Scan Avarage Per Hour',
                fontColor: '#333',
                fontSize: 14,
                fontStyle: 'bold',
              },
              ticks: {
                fontColor: '#666',
                beginAtZero: true,
                stepSize: 5,
              },
              gridLines: {
                color: '#eee',
              },
            },
          ],
        },
      },
    }
  },
  watch: {
    sessions: {
      immediate: true,
      handler() {
        this.updateChart()
      },
    },
  },
  methods: {
    updateChart() {
      const hours = Array.from(
        new Set(this.sessions.flatMap(s => s.buckets.map(b => b.hour_start))),
      ).sort()

      const datasets = this.sessions.map(s => {
        const totalScans = s.buckets.reduce((sum, b) => sum + b.scans, 0)
        const distinctHours = new Set(s.buckets.map(b => b.hour_start)).size
        const average = distinctHours > 0 ? Math.round(totalScans / (distinctHours - 1)) : 0
        const color = this.getRandomColor()
        return {
          label: `${s.username} (Total ${totalScans}, Avg ${average} /hr)`,
          data: hours.map(h => {
            const bucket = s.buckets.find(b => b.hour_start === h)
            return bucket && bucket.scans > 0 ? bucket.scans : null
          }),
          fill: false,
          tension: 0.4,
          borderColor: color,
          backgroundColor: color,
          borderWidth: 3,
          pointRadius: 5,
          pointHoverRadius: 7,
        }
      })

      this.chartData = { labels: hours, datasets }

      this.$nextTick(() => {
        this.renderChart(this.chartData, this.chartOptions)
      })
    },
    getRandomColor() {
      const palette = ['#E67E22', '#2980B9', '#2ECC71', '#E74C3C', '#8E44AD']
      return palette[Math.floor(Math.random() * palette.length)]
    },
  },
}
</script>
<style lang="scss" scoped>
.b-card {
  padding: 1rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
}

.chart-wrapper {
  height: 400px;

  canvas {
    height: 90% !important;
    width: 100% !important;
    // min-height: 250px !important; // ✅ Increased canvas height
  }
}

</style>
